export const patternMails = (emails) => {
    let array = [];
    emails.forEach((email) => {
        array.push({
            id: email.id,
            dataEnvio: email.dataEnvio,
            email: email.candidato.email,
            tipo: email.tipo,
            nome: email.candidato.nomeExibicao,
            candidato: email.candidato,
        });
    })
    return array;
}

export const patternSendCoordinator = (objetos) => {
    let array = [];
    objetos.forEach((obj) => {
        if (obj.emailEscola) 
            array.push({
                email: obj.emailEscola,
                nome: obj.nomeEscola,
                numeroSedex: obj.numero,
                ultimoStatus: obj.status,
                enderecoUnidadeRetirada: obj.enderecoUnidadeRetirada,
                regiao: obj.regiao,
                uf: obj.uf,
            });
    })
    return array;
}

export const patternSendSchoolWithResponsible = (objetos) => {
    let array = [];
    objetos.forEach((obj) => {
        if (obj.emailEscola) 
            array.push({
                id: obj.cdEscola,
                email: obj.emailEscola,
                codigoMec: obj.codigoMec,
                nome: obj.nomeEscola,
                numeroSedex: obj.numero,
                ultimoStatus: obj.status,
                enderecoUnidadeRetirada: obj.enderecoUnidadeRetirada,
                logradouroDestino: obj.enderecoEntrega.nmEndereco,
                bairroDestino: obj.enderecoEntrega.nmBairro,
                numeroDestino: obj.enderecoEntrega.nmNumero,
                cepDestino: obj.enderecoEntrega.nmCep,
                cidadeDestino: obj.enderecoEntrega.municipio.nmMunicipio,
                ufDestino: obj.enderecoEntrega.municipio.uf.cdUf,
            });

        if (obj.emailResponsavel) 
            array.push({
                id: obj.cdEscola,
                email: obj.emailResponsavel,
                codigoMec: obj.codigoMec,
                nome: obj.nomeEscola,
                numeroSedex: obj.numero,
                ultimoStatus: obj.status,
                enderecoUnidadeRetirada: obj.enderecoUnidadeRetirada,
                logradouroDestino: obj.enderecoEntrega.nmEndereco,
                bairroDestino: obj.enderecoEntrega.nmBairro,
                numeroDestino: obj.enderecoEntrega.nmNumero,
                cepDestino: obj.enderecoEntrega.nmCep,
                cidadeDestino: obj.enderecoEntrega.municipio.nmMunicipio,
                ufDestino: obj.enderecoEntrega.municipio.uf.cdUf,
            });
    })
    return array;
}